'use client';

import Icon from '@/components/ui/AppIcon';

interface ViewToggleProps {
  currentView: 'grid' | 'list';
  onViewChange: (view: 'grid' | 'list') => void;
}

const ViewToggle = ({ currentView, onViewChange }: ViewToggleProps) => {
  return (
    <div className="flex items-center space-x-2 bg-card border border-border rounded-lg p-1">
      <button
        onClick={() => onViewChange('grid')}
        className={`p-2 rounded transition-colors duration-200 ${
          currentView === 'grid' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground hover:bg-surface'
        }`}
        aria-label="Grid view"
      >
        <Icon name="Squares2X2Icon" size={20} />
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={`p-2 rounded transition-colors duration-200 ${
          currentView === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground hover:bg-surface'
        }`}
        aria-label="List view"
      >
        <Icon name="ListBulletIcon" size={20} />
      </button>
    </div>
  );
};

export default ViewToggle;